import React from 'react'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
// import { CreateBookingButton } from "./CreateBookingButton";
import { useMyBookings } from '../hooks/useMyBookings'
import { extractResponse } from '../../../utils'

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: '#FFFEFE',
        padding: theme.spacing(1),
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
    },
    headerContent: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(1),
        [theme.breakpoints.up('sm')]: {
            display: 'block',
            marginBottom: theme.spacing(0),
            width: '50%',
        },
    },
    title: {
        margin: '0px',
        marginRight: theme.spacing(2),
        fontSize: '1.25rem',
        display: 'inline',
        // fontWeight: "bold",
        marginBottom: (props) => (props === 0 ? theme.spacing(0) : theme.spacing(1)),
    },
    subTitle: {
        fontSize: '1rem',
        [theme.breakpoints.up('sm')]: {
            fontSize: '1rem',
        },
        display: 'inline',
        marginBottom: (props) => (props === 0 ? theme.spacing(0) : theme.spacing(1)),
    },
    headerWidth: {
        [theme.breakpoints.up('sm')]: {
            width: '80%',
            margin: 'auto',
        },
    },
    headerFullWidth: {
        backgroundColor: '#ffffff',
    },
}))

function Header() {
    const { data } = useMyBookings()
    const res = extractResponse(data)
    const numOfBookings = res?.data?.length || 0
    const classes = useStyles(numOfBookings)

    return (
        <div className={classes.headerFullWidth}>
            <div className={classes.headerWidth}>
                <header className={classes.root}>
                    <div className={classes.headerContent}>
                        <Typography className={classes.title} component="p">
                            My Bookings
                        </Typography>
                        <Typography className={classes.subTitle} component="p" color="textSecondary">
                            {`${numOfBookings} ${numOfBookings === 1 ? 'booking' : 'bookings'}`}
                        </Typography>
                    </div>
                    {/* <div>{res?.data && numOfBookings > 0 && <CreateBookingButton />}</div> */}
                </header>
            </div>
        </div>
    )
}

export default Header
